module.exports = __webpack_public_path__ + "static/tome_of_understanding-3d6c881ec1770f020807e6b4cc9ab574.jpeg";